import React from 'react';
export function IntroSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200" data-id="element-2994">
      <p className="text-sm text-gray-500 italic mb-6" data-id="element-2995">
        Originally posted Moldmaking Technology, October 2001
      </p>
      <div className="space-y-4 text-gray-700 text-lg leading-relaxed" data-id="element-2996">
        <p data-id="element-2997">
          There are many areas inside the typical mold shop where productivity
          can be improved. The most obvious place to look at certainly might be
          the wire EDM (WEDM) itself. When was the last time the machine had a
          tune-up or a filter change? Just like your automobile, if you do not
          take care of certain items, poor performance and costly delays can
          happen down the road. Other areas inside the mold shop may require
          some more serious thought: programming methods, tooling methods,
          automation capability, people flexibility and overall ease of how your
          entire system runs.
        </p>
        <p data-id="element-2998">
          Think for a second exactly how you would define "productivity." If
          your operator increases the servo control and cuts a set of electrodes
          or inserts fifteen minutes faster than previously, then yes, you are
          being more productive. On the other hand, if you must still manually
          set up the next set of parts with the WEDM sitting idle or the WEDM
          finishes the parts just after your operator has left for home - where
          has your productivity really gone?
        </p>
      </div>
    </div>;
}